import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArchivingMock } from "../../../components/Mockups/ArchivingMock";

export const Archiving = () => {
  const { t } = useTranslation();
  return (
    <section id="archiving" className="container section-padding pb-0">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 col-12 order-2 order-lg-1">
          <div className="bg-primary-subtle p-3 p-md-4 rounded-4 d-flex justify-content-center me-0 me-lg-4">
            <ArchivingMock />
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-12 order-1 order-lg-2">
          <div className="ms-0 ms-lg-4">
            <h3 className="mb-2 fs-2 fw-bold mb-4">
              {t("featurePages.archiving.hero.title")}
            </h3>
            <div className="mb-3">
              <div className="d-flex align-items-center gap-2 mb-2">
                <i className="bi bi-file-earmark-text fs-3 text-primary"></i>
                <h4 className="fs-4 mb-0 fw-semibold">
                  {t("featurePages.archiving.solution.benefit1.title")}
                </h4>
              </div>
              <p className="mb-0">
                {t("featurePages.archiving.solution.benefit1.description")}
              </p>
            </div>
            <div className="mb-3 mb-4">
              <div className="d-flex align-items-center gap-3 mb-2">
                <i className="bi bi-shield-check fs-3 text-primary"></i>
                <h4 className="fs-4 mb-0 fw-semibold">
                  {t("featurePages.archiving.solution.benefit2.title")}
                </h4>
              </div>
              <p className="mb-0">
                {t("featurePages.archiving.solution.benefit2.description")}
              </p>
            </div>
            <div className="mb-4">
              <Link
                to="/features/archiving"
                className="btn btn-none text-primary p-0 d-inline-flex align-items-center gap-2"
              >
                {t("features.buttons.archiving")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
